import { render } from "./social_demo.vue?vue&type=template&id=e6a996c0&scoped=true"
import script from "./social_demo.vue?vue&type=script&lang=js"
export * from "./social_demo.vue?vue&type=script&lang=js"

import "./social_demo.vue?vue&type=style&index=0&id=e6a996c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a996c0"]])

export default __exports__